<template>
  <div
    ref="chart"
    class="chart"
    style="height: 100%"
    v-loading="isLoading"
  ></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "charts2",
  data() {
    return {
      chart: null,
      isLoading: false,
      screenLength: 10,
    };
  },
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    console.log(this.dataList);
    this.initChart();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    // 初始化图表
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      // 配置图表选项
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} kg ({d}%)",
          backgroundColor: "rgba(16, 18, 27, 0.9)",
          borderColor: "rgba(255, 255, 255, 0.1)",
          textStyle: {
            color: "#e1e1e1",
          },
        },
        legend: {
          orient: "vertical",
          right: 10,
          top: "center",
          textStyle: {
            color: "#8f9bba",
          },
          itemGap: 20,
        },
        color: ["#36c17c", "#0081ff", "#a27ce6", "#fbc90d", "#e9595d"],
        series: [
          {
            name: "损耗分析",
            type: "pie",
            avoidLabelOverlap: false,
            radius: ["20%", "55%"],
            itemStyle: {
              borderColor: "#0f1016",
              borderWidth: 3,
            },
            label: {
              normal: {
                show: true,
                formatter: "{b}: {c} kg",
                color: "#e1e1e1",
              },
            },
            emphasis: {
              label: {
                normal: {
                  show: true,
                  fontSize: 14,
                  fontWeight: "bold",
                },
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            labelLine: {
              normal: {
                show: true,
                length: 10,
                length2: 15,
              },
            },
            data: this.dataList.map((v) => {
              return {
                value: v.data,
                name: v.name,
              };
            }),
          },
        ],
      };

      this.chart.setOption(option);

      // 监听dataZoom事件
      this.chart.on("dataZoom", this.handleDataZoom);
    },
    // 处理窗口大小变化
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
};
</script>

<style>
</style>